import type { ChartStyleSettings } from "../../../../../../../../../api/types/svTypes.ts";

export function getHorizontalAlignment(settings: ChartStyleSettings) {
  return settings.legend?.horizontalAlignment || "right";
}
